export const employeeSettingsActions = {
	INITIALIZE: 'initialize',
	HANDLE_TOGGLE: 'handle_toggle',
	HANDLE_MASTER_SELECTION: 'handle_master_selection',
	RESET: 'reset',
	ERROR: 'error'
};

export const employeeSettingsReducer = (state, action) => {
	switch (action.type) {
		case employeeSettingsActions.HANDLE_TOGGLE:
			if (action.payload.key === 'allowDupEERecordsEdit' && action.payload.value === true) {
				return { ...state, settings: { ...state.settings, allowDupEERecordsEdit: true, preventHiringDuplicateSSN: false } };
			}

			if (action.payload.key === 'preventHiringDuplicateSSN' && action.payload.value === true) {
				return { ...state, settings: { ...state.settings, allowDupEERecordsEdit: false, preventHiringDuplicateSSN: true } };
			}

			return { ...state, settings: { ...state.settings, [action.payload.key]: action.payload.value } };

		case employeeSettingsActions.HANDLE_MASTER_SELECTION:
			return {
				...state,
				settings: {
					...state.settings,
					[action.payload.key]: action.payload.value
				}
			};
		case employeeSettingsActions.INITIALIZE:
			return { ...state, settings: action.payload.value, savedSettings: action.payload.value };
		case employeeSettingsActions.RESET:
			return { ...state, settings: { ...state.savedSettings }, errors: {} };
		case employeeSettingsActions.ERROR:
			return { ...state, errors: action.payload };
		default:
			return state;
	}
};
